<template>
    <div>
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-2">
          <label :for="id" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2" :class="labelClass">
            {{label}}
          </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <div class="flex max-w-lg sm:max-w-xs relative">
            <input :type="type || 'text'" name="last-name" 
                :id="id" 
                :placeholder="placeholder"
                :value="modelValue"
                :readonly="readonly"
                @input="this.$emit('update:modelValue', $event.target.value)"                
                class="block flex-grow shadow-sm sm:text-sm border-gray-300 rounded-md"
                :class="{ 'bg-transparent text-gray-700 focus:ring-gray-300 focus:border-gray-300': readonly,
                          'focus:ring-blue-500 focus:border-blue-500 ': !readonly}">
                <slot v-if="hasSlot"/>
            </div>
              <div v-if="error" class="max-w-lg sm:max-w-xs">
                <p v-if="!isMultiError" class="mt-2 text-sm text-red-600" :id="id+'-error'">{{error}}</p>
                <div v-if="isMultiError">
                  <p v-for="cerror, idx in error" :key="idx" class="mt-2 text-sm text-red-600" :id="id+'-error'">{{cerror}}</p>
                </div>
              </div>
          </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
//import { ExclamationCircleIcon } from '@heroicons/vue/solid';

export default {
    components: {
//      ExclamationCircleIcon
    },
    computed: {
      hasSlot: function() {
        return this.$slots.default;
      },
      isMultiError: function() {
        return this.error && Array.isArray(this.error)
      }
    },
    props: [
        'id',
        'label',
        'labelClass',
        'error',
        'type',
        'placeholder',
        'modelValue',
        'pre',
        'readonly',
        'small'
    ]
};
</script>